import type { ReactNode } from 'react'

export const CallControlButton = ({
  icon,
  onClick,
  backgroundColor,
  disabled = false,
}: {
  icon: ReactNode
  onClick?: VoidFunction
  backgroundColor: string
  disabled?: boolean
}) => {
  return (
    <button
      css={{
        borderRadius: '100%',
        backgroundColor,
        height: '40px',
        width: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: disabled ? 'default' : 'pointer',
        flexShrink: 0,
        border: 'none',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </button>
  )
}
